import { insertHtmlFragment } from '@otto-ec/global-resources/dom';
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

/*               */
var o_order = window.o_order || {};
o_order.basket = o_order.basket || {};

o_order.basket.serverBoundaryBuilder = function () {
    'use strict';

    const module = {},
        servletContext = '/order';

    module.saveChangedQuantity = async function (basketItemId, quantityValue, successHandler, errorHandler) {
        const parameters = {
            basketItemId: basketItemId,
            quantity: quantityValue
        };

        try {
            const response = await fetch(servletContext + '/basket/item/modifyQuantity', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: o_util.core.serialize(parameters)
            });
            const responseText = await response.text();
            const handler = o_order.utils.handleAjax(function () {
                successHandler(responseText);
            }, errorHandler);
            await handler(response);
        } catch (e) {
            if (o_global.debug.status().activated) {
                console.error(e);
            }
        }
    };

    module.deleteItem = function (basketItemId, successHandler, errorHandler) {
        fetch(servletContext + '/basket/item/delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: 'basketItemId=' + basketItemId
        })
            .then(
                o_order.utils.handleAjax(
                    async function (response) {
                        const responseText = await response.text();
                        successHandler(responseText, o_order.utils.readResponseRedirectTo(response));
                    },
                    async function (response) {
                        errorHandler(await response.text());
                    }
                )
            )
            .catch(function (error) {
                if (o_global.debug.status().activated) {
                    console.error(error);
                }
            });
    };

    module.reloadBasket = async function () {
        const response = await fetch('/order/basketPart');
        if (response.status !== 200) {
            throw new Error(`Could not reload basket. Status code ${response.status}`);
        }
        return response.text();
    };

    return module;
};

o_order.basket.viewBuilder = function (window) {
    'use strict';

    const module = {},
        basket_selector = 'order_js_basket',
        item_selector = 'order_js_item',
        itemQuantityDropdownSelector = 'order_js_quantitySelection';

    module.getItemById = function (basketItemId) {
        const basket = document.getElementsByClassName(basket_selector)[0];

        return basket ? basket.querySelector('.' + item_selector + "[data-basketitemid='" + basketItemId + "']") : undefined;
    };

    module.getQuantitySelectionForItem = function (item) {
        return item ? item.getElementsByClassName(itemQuantityDropdownSelector)[0] : undefined;
    };

    module.getItemQuantity = function (basketItemId) {
        const item = module.getItemById(basketItemId);
        return module.getQuantitySelectionForItem(item)?.value;
    };

    module.extractTrackingBasketId = function (basketItemId) {
        const item = this.getItemById(basketItemId);
        return item ? item.getAttribute('data-trackingbasketid') : '';
    };

    module.readBasketItemIdFor = function (elem) {
        const parent = o_util.dom.getParentByClassName(elem, item_selector),
            basketItemChild = parent.getElementsByClassName('order_js_basketItemId')[0];

        return basketItemChild ? basketItemChild.value : '';
    };

    module.extractVariationId = function (basketItemId) {
        var item = this.getItemById(basketItemId);
        return item ? item.getAttribute('data-variation') : '';
    };

    /**
 *
 */
    module.setBasketContent = function (html) {
        const basket = document.getElementsByClassName(basket_selector)[0];

        if (basket) {
            insertHtmlFragment(html, basket, { replace: true });
            o_order.utils.preload(document.getElementById('order_js_shoppagesStaticResources'));
        }

        /*                                                    */
        const globalErrorMessage = document.getElementsByClassName('order_js_errorBasketMessage')[0];
        if (globalErrorMessage) {
            o_util.animation.scrollTo(0, 100);
        }
    };

    module.fireBasketChanged = function () {
        o_order.common.basketChange.triggerBasketChange();
    };

    module.initializeAssetElements = function () {
        o_global.eventQBus.emit('assets.tooltip.init');
        o_global.eventQBus.emit('assets.accordion.init');
        o_global.eventQBus.emit('assets.dropdown.init');
    };

    module.initializeRecoElement = function () {
        const selector = '.reco_emptyBasket_skeleton_injection_container.reco_skeleton_needsInitialization';
        const eventMergeId = o_order.tracking.getEventMergeId();
        o_global.eventQBus.emit('ft6bcn.reco.start_empty_basket', { selector, eventMergeId });
    };

    module.registerChangeQuantityHandler = function (handler) {
        var basket = document.getElementsByClassName(basket_selector)[0];

        if (basket) {
            o_util.event.delegate(basket, 'oc-property-change', '.' + itemQuantityDropdownSelector, function () {
                var quantity = this.value,
                    basketItemId = module.readBasketItemIdFor(this);

                handler(basketItemId, quantity);
            });
        }
    };

    module.registerSwipeHandler = function () {
        const basket = document.getElementsByClassName(basket_selector)[0];
        if (basket) {
            o_order.basket.initSwipeToDelete();
        }
    };

    module.registerButtonLinks = function () {
        const taggedButtons = document.getElementsByClassName('or_js_basketPage__taggedButton');
        Array.from(taggedButtons).forEach(btn =>
            btn.addEventListener('click', () => {
                o_order.tracking.submitEvent({ name: 'click', features: [] }, { order_Flow: [btn.dataset.linkLabel] });
                o_order.utils.goto(window, btn.getAttribute('data-href'));
            })
        );
    };

    module.registerProductDataSheetClickHandler = function (htmlElement) {
        const productDataSheetLinks = htmlElement.getElementsByClassName('or_js_basketItem__energyEfficiencyClassDataSheet');
        Array.from(productDataSheetLinks).forEach(link => {
            link.addEventListener('click', () => {
                o_order.tracking.submitEvent({ name: 'click', features: [] }, { order_ClickedLink: ['ProductSheet'] });
            });
        });
    };

    module.onProductDataSheetOpenedClickHandler = function (sheetMenuBar) {
        sheetMenuBar?.addEventListener('click', clickEvent => {
            if (clickEvent.target.tagName !== 'A') {
                /*                                                                                        */
                return;
            }
            o_order.tracking.submitEvent({ name: 'click', features: [] }, { order_ClickedLink: ['ProductSheet'] });
        });
    };

    module.registerProductDataSheetHandlers = function () {
        o_global.eventQBus.on('assets.sheet.opened', event => {
            if (event.id === 'or_eekSheet') {
                module.onProductDataSheetOpenedClickHandler(event.sheetMenuBar);
            }
        });
        module.registerProductDataSheetClickHandler(document);
    };

    module.registerEekIconHandlers = function () {
        const eekLabels = document.getElementsByClassName('or_js_basketItem__energyEfficiencyClassLabel');
        Array.from(eekLabels).forEach(label =>
            label.addEventListener('click', () => {
                o_order.tracking.submitEvent({ name: 'click', features: [] }, { order_ClickedLink: ['EnergyEfficiency'] });
            })
        );
    };

    module.registerDeleteButtonHandler = function (handler) {
        const basket = document.getElementsByClassName(basket_selector)[0];

        if (basket) {
            o_util.event.delegate(basket, 'click', '.order_js_kreuz', function () {
                const basketItemId = module.readBasketItemIdFor(this);

                handler(basketItemId);
            });
        }
    };

    module.itemRemoved = function (basketItemId, handler) {
        const item = this.getItemById(basketItemId);

        o_util.animation.fadeOut(item, function () {
            item.style.display = 'none';
            handler();
        });
    };

    module.startDelete = function (basketItemId) {
        const item = document.querySelector('.' + basket_selector + ' .' + item_selector + "[data-basketitemid='" + basketItemId + "']");
        if (item) {
            o_order.common.buttons.toggleLoading(item.querySelectorAll('.order_js_kreuz'));
        }
    };

    module.hideDropdown = function (basketItemId) {
        const quantitySelection = this.getQuantitySelectionForItem(this.getItemById(basketItemId));

        if (quantitySelection) {
            quantitySelection.style.display = 'none';
        }
    };

    module.showQuantitySpinner = function (basketItemId) {
        const item = document.querySelector('.' + basket_selector + ' .' + item_selector + "[data-basketitemid='" + basketItemId + "']");

        if (item) {
            o_order.common.buttons.toggleLoading(item.querySelectorAll('.' + itemQuantityDropdownSelector));
        }
    };

    module.showChangeQuantityError = function (basketItemId, error) {
        var item = document.querySelector('.' + basket_selector + ' .' + item_selector + "[data-basketitemid='" + basketItemId + "']");

        if (item) {
            const messageContainer = item.querySelector('.or_js_basketItem_modificationMessages');
            messageContainer.innerHTML = error;
            messageContainer.style.display = 'block';
            const selectBox = item.querySelector('.order_js_quantitySelection');
            selectBox.value = selectBox.getAttribute('data-old-quantity');
            o_order.common.buttons.toggleLoading(item.querySelectorAll('.' + itemQuantityDropdownSelector));
        }
    };

    module.redirectTo = function (url) {
        o_order.utils.goto(window, url);
    };

    module.updateBasket = function (basketContent) {
        module.setBasketContent(basketContent);
        module.fireBasketChanged();
        module.initializeAssetElements();
        module.initializeRecoElement();
        module.registerButtonLinks();
        module.registerProductDataSheetHandlers();
        module.registerEekIconHandlers();
        module.registerSwipeHandler();
    };

    return module;
};

o_order.basket.presenterBuilder = function (view, service) {
    'use strict';

    const module = {};

    module.reloadBasket = function () {
        return service
            .reloadBasket()
            .then(view.updateBasket)
            .catch(error => console.error(error));
    };

    module.registerReloadBasketEvent = function () {
        o_global.eventQBus.on('ft1.order-core.reloadBasket', () => {
            service
                .reloadBasket()
                .then(view.updateBasket)
                .catch(error => console.error(error));
        });
    };

    module.changeQuantity = function (basketItemId, selectedQuantity) {
        view.showQuantitySpinner(basketItemId);

        service.saveChangedQuantity(
            basketItemId,
            selectedQuantity,
            module.createSaveChangedQuantitySuccessCallback(basketItemId),
            module.createSaveChangedQuantityErrorCallback(basketItemId)
        );
    };

    module.createSaveChangedQuantitySuccessCallback = function (basketItemId) {
        return function (data) {
            view.updateBasket(data);

            /*                         */
            const variationId = view.extractVariationId(basketItemId);
            o_order.tracking.submitEventMerge({
                name: 'change',
                features: [
                    { id: 'order_variation_ch_q', name: 'VariationQuantityChanged', status: 'changed', labels: {} },
                    {
                        id: 'order_variation_ch_q_1',
                        variationId: variationId,
                        name: 'Variation',
                        parentId: 'order_variation_ch_q',
                        status: 'changed',
                        labels: {}
                    }
                ]
            });
        };
    };

    module.createSaveChangedQuantityErrorCallback = function (basketItemId) {
        return async function (response) {
            const responseText = await response.text();
            if (response.status === 400) {
                /*                                          */
                view.showChangeQuantityError(basketItemId, responseText);
            } else {
                /*                                                                 */
                /*                                 */
                view.updateBasket(responseText);
            }
        };
    };

    /**
 *
 *
 */
    module.deleteItem = function (basketItemId, interactionType = 'Button') {
        const variationId = view.extractVariationId(basketItemId);
        const trackingBasketId = view.extractTrackingBasketId(basketItemId);
        const basketItemQuantity = view.getItemQuantity(basketItemId);

        const trackFeature = generateId =>
            o_order.tracking.submitEventMerge(
                {
                    name: 'delete',
                    features: [
                        {
                            id: 'order_variation_del_1',
                            variationId: variationId,
                            name: 'Variation',
                            parentId: 'order_variation_del_2',
                            status: 'deleted',
                            labels: {
                                order_BasketId: [trackingBasketId],
                                order_BasketItemId: [basketItemId]
                            }
                        },
                        {
                            id: 'order_variation_del_2',
                            name: 'BasketVariationDeleted',
                            status: 'success',
                            labels: {
                                order_ItemDeletionInteractionType: [interactionType],
                                order_ItemDeletionQuantity: [basketItemQuantity]
                            }
                        }
                    ]
                },
                generateId
            );

        const reload = function (content, redirectTo) {
            if (redirectTo) {
                trackFeature(true);
                view.redirectTo(redirectTo);
            } else {
                view.updateBasket(content);
                trackFeature(false);
            }
        };

        const fadeOutAndReload = function (content, redirectTo) {
            view.itemRemoved(basketItemId, function () {
                reload(content, redirectTo);
            });
        };

        if (interactionType === 'Button') {
            view.startDelete(basketItemId);
            service.deleteItem(basketItemId, fadeOutAndReload, view.updateBasket);
        } else {
            service.deleteItem(basketItemId, reload, view.updateBasket);
        }
    };

    module.registerItemSwipeDeleteEventListener = function () {
        o_global.eventQBus.on('ft1.order-core.deleteBasketItem', event => {
            module.deleteItem(event.basketItemId, event.interactionType);
        });
    };

    module.init = function () {
        view.registerDeleteButtonHandler(module.deleteItem);
        view.registerChangeQuantityHandler(module.changeQuantity);
        view.registerButtonLinks();
        view.registerProductDataSheetHandlers();
        view.registerEekIconHandlers();
        view.registerSwipeHandler();
        module.registerItemSwipeDeleteEventListener();
        module.registerReloadBasketEvent();
    };

    return module;
};
